"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingItem = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/list-item/list-item");
const shared_styles_1 = require("@/stylesheets/shared.styles");
/**
 * <mm-setting-item icon="bell" label="알림" description="...">
 *   <mm-switch slot="action"></mm-switch>
 * </mm-setting-item>
 */
let SettingItem = class SettingItem extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.label = '';
        this.description = '';
        this.disabled = false;
    }
    render() {
        return (0, lit_1.html) `
      <mm-list-item
        size=${this.description ? 'medium' : 'small'}
        icon=${this.icon || lit_1.nothing}
        label=${this.label}
        description=${this.description}
      >
        <slot name="action" slot="trailing" @slotchange=${this.handleActionSlotChange}></slot>
      </mm-list-item>
    `;
    }
    updated(changed) {
        if (changed.has('disabled'))
            this.handleActionSlotChange();
    }
    handleActionSlotChange() {
        this.actions.forEach(action => {
            if ('disabled' in action)
                action.disabled = this.disabled;
        });
    }
};
SettingItem.styles = (0, lit_1.css) `
    :host {
      display: block;
    }

    :host([disabled]) {
      ${shared_styles_1.disabledStyles};
      pointer-events: none;
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], SettingItem.prototype, "label", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], SettingItem.prototype, "description", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], SettingItem.prototype, "icon", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean, reflect: true })
], SettingItem.prototype, "disabled", void 0);
__decorate([
    (0, decorators_js_1.queryAssignedElements)({ slot: 'action', flatten: true })
], SettingItem.prototype, "actions", void 0);
SettingItem = __decorate([
    (0, decorators_js_1.customElement)('mm-setting-item')
], SettingItem);
exports.SettingItem = SettingItem;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2V0dGluZy1pdGVtLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsic2V0dGluZy1pdGVtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUFvRDtBQUNwRCxxREFBa0Y7QUFJbEYsbURBQWdEO0FBQ2hELCtEQUE0RDtBQUk1RDs7OztHQUlHO0FBRUksSUFBTSxXQUFXLEdBQWpCLE1BQU0sV0FBWSxTQUFRLGdCQUFVO0lBQXBDOztRQVd1QixVQUFLLEdBQUcsRUFBRSxDQUFBO1FBQ1YsZ0JBQVcsR0FBRyxFQUFFLENBQUE7UUFFQSxhQUFRLEdBQUcsS0FBSyxDQUFBO0lBMEI5RCxDQUFDO0lBdEJDLE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBOztlQUVBLElBQUksQ0FBQyxXQUFXLENBQUMsQ0FBQyxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUMsT0FBTztlQUNyQyxJQUFJLENBQUMsSUFBSSxJQUFJLGFBQU87Z0JBQ25CLElBQUksQ0FBQyxLQUFLO3NCQUNKLElBQUksQ0FBQyxXQUFXOzswREFFb0IsSUFBSSxDQUFDLHNCQUFzQjs7S0FFaEYsQ0FBQTtJQUNILENBQUM7SUFFUyxPQUFPLENBQUMsT0FBNkI7UUFDN0MsSUFBSSxPQUFPLENBQUMsR0FBRyxDQUFDLFVBQVUsQ0FBQztZQUFFLElBQUksQ0FBQyxzQkFBc0IsRUFBRSxDQUFBO0lBQzVELENBQUM7SUFFTyxzQkFBc0I7UUFDNUIsSUFBSSxDQUFDLE9BQU8sQ0FBQyxPQUFPLENBQUMsTUFBTSxDQUFDLEVBQUU7WUFDNUIsSUFBSSxVQUFVLElBQUksTUFBTTtnQkFBRSxNQUFNLENBQUMsUUFBUSxHQUFHLElBQUksQ0FBQyxRQUFRLENBQUE7UUFDM0QsQ0FBQyxDQUFDLENBQUE7SUFDSixDQUFDOztBQXRDTSxrQkFBTSxHQUFHLElBQUEsU0FBRyxFQUFBOzs7Ozs7UUFNYiw4QkFBYzs7O0dBR25CLENBQUE7QUFDMkI7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDOzBDQUFXO0FBQ1Y7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO2dEQUFpQjtBQUNoQjtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7eUNBQWdCO0FBQ0M7SUFBM0MsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE9BQU8sRUFBRSxPQUFPLEVBQUUsSUFBSSxFQUFFLENBQUM7NkNBQWlCO0FBRTVEO0lBREMsSUFBQSxxQ0FBcUIsRUFBQyxFQUFFLElBQUksRUFBRSxRQUFRLEVBQUUsT0FBTyxFQUFFLElBQUksRUFBRSxDQUFDOzRDQUNuQjtBQWhCM0IsV0FBVztJQUR2QixJQUFBLDZCQUFhLEVBQUMsaUJBQWlCLENBQUM7R0FDcEIsV0FBVyxDQXdDdkI7QUF4Q1ksa0NBQVcifQ==